// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QVW6v","logo_body":"Header_logo_body__F3Hsm","text":"Header_text__95FtQ"};